import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from 'src/app/shared/shared.module';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { CsvSeleccionProcesoComponent } from './csv-seleccion-proceso/csv-seleccion-proceso.component';
import { CsvSeleccionPromocionComponent } from './csv-seleccion-promocion/csv-seleccion-promocion.component';
import { CsvEntrevistaSalidaComponent } from './csv-entrevista-salida/csv-entrevista-salida.component';
import { CsvCampeonCompromisoComponent } from './csv-campeon-compromiso/csv-campeon-compromiso.component';
import { SeleccionRoutingModule } from './seleccion-routing.module';
import { CsvSeleccionCatalogosComponent } from './csv-seleccion-catalogos/csv-seleccion-catalogos.component';


@NgModule({
  declarations: [
    CsvSeleccionProcesoComponent,
    CsvSeleccionPromocionComponent,
    CsvEntrevistaSalidaComponent,
    CsvCampeonCompromisoComponent,
    CsvSeleccionCatalogosComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
    SeleccionRoutingModule,
  ],
  exports: [
    CsvSeleccionProcesoComponent,
    CsvSeleccionPromocionComponent,
    CsvEntrevistaSalidaComponent,
    CsvCampeonCompromisoComponent
  ],
})
export class SeleccionCargasModule { }
